exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".st0[data-v-a7fed2e4]{fill:#1d1d1b;stroke:#000;stroke-width:.5;stroke-miterlimit:10}.st1[data-v-a7fed2e4]{fill:#1d1d1b}.st2[data-v-a7fed2e4]{display:none}.st3[data-v-a7fed2e4]{display:inline}.st4[data-v-a7fed2e4]{opacity:.34;clip-path:url(#SVGID_00000039820520451460623940000008742108583065984183_)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a7fed2e4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Esayac/AlternatifLogo.vue
// module id = 1103
// module chunks = 0